import { PROFILE_STORAGE_KEY } from "../../../components/Forms/networking/otpService";

interface UMPContext {
  UMP_ID: string;
  UMPO_Added?: boolean;
  [key: string]: any; // Allow for other properties
}

export function checkForExistingUMPInSessionStorage(): UMPContext | false {
  // Check if we have a UserMarketingProfile stored in session storage
  const storedContext = sessionStorage.getItem(PROFILE_STORAGE_KEY);

  if (!storedContext) return false;

  const parsedContext = JSON.parse(storedContext);
  return parsedContext;
}
